import { render, staticRenderFns } from "./EventsListViewModeSelector.vue?vue&type=template&id=528a0602"
import script from "./EventsListViewModeSelector.vue?vue&type=script&lang=js"
export * from "./EventsListViewModeSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports